import { createTheme, Radio, RadioProps, styled, ThemeProvider } from '@mui/material'
import { useAppSelector } from '~/app/hooks'
import { currentTheme } from '~/redux/features'

const BpIcon = styled('span')(({ theme }) => ({
  borderRadius: '50%',
  width: 16,
  height: 16,
  boxShadow:
    theme.palette.mode === 'dark'
      ? 'inset 0 0 0 4.5px rgb(255 255 255 / 44%), inset 0 -1px 0 rgba(16, 22, 26, .1)'
      : 'inset 0 0 0 4.5px rgb(16 22 26 / 13%), inset 0 -1px 0 rgba(16,22,26,.1)',
  backgroundColor: theme.palette.mode === 'dark' ? '' : '#f5f8fa',
  backgroundImage:
    theme.palette.mode === 'dark'
      ? ''
      : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2
  },
  'input:hover:not([disabled]) ~ &': {
    backgroundColor: theme.palette.mode === 'dark' ? '' : '#ebf1f5'
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background:
      theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)'
  }
}))

const BpCheckedIcon = styled(BpIcon)(({ theme }) => ({
  backgroundColor: 'var(--primary-bg)',
  boxShadow: 'none',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&:before': {
    display: 'block',
    width: 16,
    height: 16,
    backgroundImage:
      theme.palette.mode === 'dark'
        ? 'radial-gradient(var(--dark-chart-bg),var(--dark-chart-bg) 28%,transparent 32%)'
        : 'radial-gradient(#fff,#fff 30%,transparent 30%)',
    content: '""'
  },
  'input:hover:not([disabled]) ~ &': {
    backgroundColor: '#009cc1'
  }
}))

// Inspired by blueprintjs
export function BpRadio(props: RadioProps) {
  const theme = useAppSelector(currentTheme)

  const customTheme = createTheme({
    palette: {
      mode: theme
    }
  })

  return (
    <ThemeProvider theme={customTheme}>
      <Radio
        disableRipple
        color='default'
        checkedIcon={<BpCheckedIcon />}
        icon={<BpIcon />}
        {...props}
      />
    </ThemeProvider>
  )
}
